"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecognizedCustomerInfo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const flora_react_1 = require("@grupoboticario/flora-react");
const flora_react_icons_1 = require("@grupoboticario/flora-react-icons");
/**
 * @Component
 * Exibe informações de um cliente final reconhecido, sem modificar o valor original.
 * @param {string} name Nome do cliente final reconhecido
 * @param {string} phoneNumber Número de telefone do cliente final reconhecido
 * @example
 * <RecognizedCustomerInfo name='João da Silva' phoneNumber='(11) 99999-9999' />
 * <RecognizedCustomerInfo name='Jo*******' phoneNumber='(11) 99999-****' />
 */
const RecognizedCustomerInfo = ({ name, phoneNumber }) => ((0, jsx_runtime_1.jsxs)(flora_react_1.Flex, Object.assign({ gap: 10 }, { children: [(0, jsx_runtime_1.jsx)(flora_react_icons_1.PersonCircleIcon, {}), (0, jsx_runtime_1.jsxs)(flora_react_1.Flex, Object.assign({ direction: 'column', gap: 8 }, { children: [(0, jsx_runtime_1.jsx)(flora_react_1.Text, Object.assign({ size: 'bodyLargeShort', color: '$dark-light' }, { children: name })), (0, jsx_runtime_1.jsx)(flora_react_1.Text, Object.assign({ size: 'auxiliarMini', color: '$medium-medium' }, { children: phoneNumber }))] }))] })));
exports.RecognizedCustomerInfo = RecognizedCustomerInfo;
